export default __webpack_public_path__ + "static/media/services3.c96e35d2.png";